import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSwimmingPool,
    faSun,
    faDumbbell,
    faLaptop,
    faBicycle,
    faShuttleVan,
    faBaby,
    faDoorClosed
} from '@fortawesome/free-solid-svg-icons';
import { components } from '../components';
import { useLocation } from 'react-router-dom';
import { Feature } from '../../src/types/types'

export const AminitiesList: React.FC = () => {
    const location = useLocation();
    const features = location.state?.features || [];
    const [amenities, setAmenities] = useState<Feature[]>([])




    const amenitiesList = [
        { id: 1, name: 'Infinity Pool', icon: <FontAwesomeIcon icon={faSwimmingPool} /> },
        { id: 2, name: 'Sunset View', icon: <FontAwesomeIcon icon={faSun} /> },
        { id: 3, name: 'Gym Center', icon: <FontAwesomeIcon icon={faDumbbell} /> },
        { id: 4, name: 'Work Station', icon: <FontAwesomeIcon icon={faLaptop} /> },
        // { id: 5, name: 'Free Bike', icon: <FontAwesomeIcon icon={faBicycle} /> },
        // { id: 6, name: 'Airport Shuttle', icon: <FontAwesomeIcon icon={faShuttleVan} /> },
        { id: 7, name: 'Baby Ground', icon: <FontAwesomeIcon icon={faBaby} /> },
        { id: 8, name: 'Meeting Room', icon: <FontAwesomeIcon icon={faDoorClosed} /> },
    ];


    useEffect(() => {
        const featuresFromLocation = location.state?.features || [];
        setAmenities(featuresFromLocation);
    }, [location.state]);


    // Start Component Here 

    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                goBack={true}
                filter={true}
                title="Amenities"
            />
        );
    };
    const renderAmenities = (): JSX.Element => {
        return (
            <main style={{ paddingBottom: 0 }}>
                <div style={{ paddingTop: 10, paddingBottom: 20 }}>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px', padding: "0px 14px 0px 14px" }}>
                        {amenities.map((amenity) => (
                            <div
                                key={amenity.feature_id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    width: '100%',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                }}
                            >

                                <span style={{ marginRight: '8px' }}>
                                    {/* {amenity.icon} */}
                                    <img src={amenity.icon} alt="" style={{ width: "30px" }} />
                                </span>
                                <span>{amenity.feature_name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        );
    };
    return (
        <>
            {renderHeader()}
            {renderAmenities()}
        </>
    );
};
